import { cacheDom } from "../utils/QuerySelector.js"

const dom = {}
const qs = {
  fastPaymentTrigger: 'data-accelerated-checkout-trigger',
  fastPaymentContent: 'data-accelerated-checkout-content',
  fastPaymentClose: 'data-accelerated-checkout-close',
}
const qsAll = {
  
}

const toggleAcceleratedCheckout = (toggle=true) => {
  if(toggle) {
    dom.fastPaymentContent.classList.remove('!hidden')
    dom.fastPaymentTrigger.classList.add('!hidden')
    dom.fastPaymentTrigger.setAttribute('aria-hidden', 'true')
  } else {
    dom.fastPaymentContent.classList.add('!hidden')
    dom.fastPaymentTrigger.classList.remove('!hidden')
    dom.fastPaymentTrigger.setAttribute('aria-hidden', 'false')
  }
}

export const setupProductAdditionals = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.fastPaymentTrigger) {
    dom.fastPaymentTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      toggleAcceleratedCheckout(!dom.fastPaymentTrigger.classList.contains('!hidden'))
    })
    dom.fastPaymentClose.addEventListener('click', (e) => {
      e.preventDefault()
      toggleAcceleratedCheckout(false)
    })
  }
}